module.exports = __webpack_public_path__ + "static/img/top-001.bae559a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top-001.svg
// module id = yOyn
// module chunks = 1